<template>
  <b-card no-body>
    <b-card-header class="border-0">
      <h3 class="mb-0">Listado de preguntas y respuestas</h3>
    </b-card-header>
    <b-list-group>
      <b-list-group-item v-for="item of list" :key="item._id">
        <h3>{{item.title}}</h3>
        <p style="white-space: break-spaces">{{item.description}}</p>
        <b-button-group class="position-absolute right-1 top-1" size="sm" @click="edit(item)">
          <b-button variant="primary">
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button variant="danger" @click="remove(item)">
            <i class="ni ni-fat-remove"></i>
          </b-button>
        </b-button-group>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";

export default {
  name: "FaqList",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      list: [],
      search: '',
    };
  },
  methods: {
    getList() {
      get("faqs", null, true).then(({data}) => {
        this.list = data
      })
    },
    remove(item){
      post(`faqs/delete/${item._id}`, null, true).then(() => {
        this.getList()
        this.showMessage('Pregunta eliminada')
      })
    },
    edit(item){
      this.$emit('edit', item)
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
  },
  mounted() {
    this.getList()
  },
}
</script>

<style scoped>

</style>
